/**
 * NV Add-on — Horizon native + reliable (FINAL)
 * - Horizon adds MAIN normally
 * - Addon added ONLY after SUCCESS CartAddEvent
 * - If main fails/max qty exceeded → addon will NOT add
 * - Same addon allowed for different products
 * - No drawer manipulation
 * - Bubble stable across navigation
 */

const FALLS_PICO = "52620112855337";
const FALLS_PICO_KUCCHU = "52620116459817";
const GIFT_WRAP = "52620117868841";

function updateFallsPicoDeliveryNote(scope = document) {
  const wrappers = scope.querySelectorAll?.(".addon-services") || [];

  wrappers.forEach((wrapper) => {
    const note = wrapper.querySelector("#falls-pico-delivery-note");
    if (!note) return;

    const selectedService =
      wrapper.querySelector('input[name="addon_service"]:checked')?.value || "";

    if (selectedService === FALLS_PICO || selectedService === FALLS_PICO_KUCCHU) {
      note.style.display = "block";
    } else {
      note.style.display = "none";
    }
  });
}

function updateGiftWrapMessageBox(scope = document) {
  const wrappers = scope.querySelectorAll?.(".addon-services") || [];

  wrappers.forEach((wrapper) => {
    const checkbox = wrapper.querySelector("#gift_wrap_addon");
    const box = wrapper.querySelector("#gift_wrap_message_wrapper");
    if (!checkbox || !box) return;

    if (checkbox.checked) {
      box.style.display = "block";
    } else {
      box.style.display = "none";
    }
  });
}

if (!window.__NV_ADDON_HORIZON_NATIVE_FINAL__) {
  window.__NV_ADDON_HORIZON_NATIVE_FINAL__ = true;

  const INTENT = new Map(); // product-form-component -> intent

  function shortTitle(title) {
    if (!title) return "Selected saree...";
    return title.trim().split(/\s+/).slice(0, 3).join(" ") + "...";
  }

  async function getCart() {
    const r = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!r.ok) throw new Error("cart read failed");
    return r.json();
  }

  function getSectionIds() {
    const nodes = document.querySelectorAll("cart-items-component");
    const ids = [];
    nodes.forEach((n) => {
      if (n instanceof HTMLElement && n.dataset.sectionId) ids.push(n.dataset.sectionId);
    });
    return ids;
  }

  async function horizonAddLine({ id, quantity = 1, properties = {} }) {
    const url = window.Theme?.routes?.cart_add_url || "/cart/add.js";

    const fd = new FormData();
    fd.append("id", String(id));
    fd.append("quantity", String(quantity));

    for (const [k, v] of Object.entries(properties)) {
      fd.append(`properties[${k}]`, String(v));
    }

    const sections = getSectionIds();
    if (sections.length) fd.append("sections", sections.join(","));

    const res = await fetch(url, {
      method: "POST",
      body: fd,
      headers: { Accept: "text/html" },
    });

    const json = await res.json();
    if (json?.status) throw new Error(json.message || json.description || "Addon add failed");
    return json;
  }

  document.addEventListener("change", (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    if (target.matches('input[name="addon_service"]')) {
      const form = target.closest('form[data-type="add-to-cart-form"]') || document;
      updateFallsPicoDeliveryNote(form);
    }

    if (target.matches("#gift_wrap_addon")) {
      const form = target.closest('form[data-type="add-to-cart-form"]') || document;
      updateGiftWrapMessageBox(form);
    }
  });

  /* -------------------------------------------------------
     Capture intent BEFORE Horizon submit (no interference)
  -------------------------------------------------------- */
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!form.querySelector(".addon-services")) return;

      const pfc = form.closest("product-form-component");
      if (!pfc) return;

      const serviceId = form.querySelector('input[name="addon_service"]:checked')?.value || "";
      const giftChecked = !!form.querySelector("#gift_wrap_addon")?.checked;

      if (!serviceId && !giftChecked) {
        INTENT.delete(pfc);
        updateFallsPicoDeliveryNote(form);
        updateGiftWrapMessageBox(form);
        return;
      }

      const title =
        pfc.getAttribute("data-product-title") ||
        document.querySelector("h1")?.textContent ||
        "";

      INTENT.set(pfc, {
        ts: Date.now(),
        serviceId,
        giftChecked,
        giftMessage: form.querySelector("#gift_wrap_message")?.value?.trim() || "",
        label: shortTitle(title),
      });

      updateFallsPicoDeliveryNote(form);
      updateGiftWrapMessageBox(form);
    },
    true
  );

  /* -------------------------------------------------------
     Hook into Horizon native CartAddEvent
  -------------------------------------------------------- */
  (async () => {
    let CartAddEventName = null;
    let CartUpdateEventClass = null;

    try {
      const mod = await import("@theme/events");
      CartAddEventName = mod?.CartAddEvent?.eventName || null;
      CartUpdateEventClass = typeof mod?.CartUpdateEvent === "function" ? mod.CartUpdateEvent : null;
    } catch {
      return;
    }

    if (!CartAddEventName) return;

    async function dispatchCartUpdate(source = "nv-addon") {
      if (!CartUpdateEventClass) return;
      try {
        const cart = await getCart();
        document.dispatchEvent(new CartUpdateEventClass(cart, "nv-addon", { source }));
      } catch {}
    }

    window.addEventListener("pageshow", () => dispatchCartUpdate("nv-pageshow"));
    document.addEventListener("DOMContentLoaded", () => {
      dispatchCartUpdate("nv-domcontent");
      updateFallsPicoDeliveryNote(document);
      updateGiftWrapMessageBox(document);
    });

    async function handleCartAdd(evt, pfc) {
      if (evt.currentTarget !== pfc) return;

      const didError =
        evt?.detail?.didError === true ||
        evt?.detail?.data?.didError === true ||
        evt?.detail?.resource?.status === true ||
        evt?.detail?.data?.status === true;

      if (didError) {
        INTENT.delete(pfc);
        return;
      }

      const intent = INTENT.get(pfc);
      INTENT.delete(pfc);
      if (!intent) return;

      if (Date.now() - intent.ts > 4000) return;

      const { serviceId, giftChecked, giftMessage, label } = intent;

      try {
        if (serviceId === FALLS_PICO || serviceId === FALLS_PICO_KUCCHU) {
          await horizonAddLine({
            id: serviceId,
            quantity: 1,
            properties: { "Service for": label },
          });
        }

        if (giftChecked) {
          const props = { "Gift wrap for": label };
          if (giftMessage) props["Gift message"] = giftMessage;

          await horizonAddLine({
            id: GIFT_WRAP,
            quantity: 1,
            properties: props,
          });
        }

        await dispatchCartUpdate("nv-after-addon");
      } catch (e) {
        console.warn("NV addon skipped", e);
        await dispatchCartUpdate("nv-addon-error-refresh");
      }
    }

    function attach(pfc) {
      if (!(pfc instanceof HTMLElement)) return;
      if (pfc.__nvAddonAttached) return;
      pfc.__nvAddonAttached = true;

      pfc.addEventListener(CartAddEventName, (evt) => handleCartAdd(evt, pfc));
      updateFallsPicoDeliveryNote(pfc);
      updateGiftWrapMessageBox(pfc);
    }

    document.querySelectorAll("product-form-component").forEach(attach);

    const mo = new MutationObserver(() => {
      document.querySelectorAll("product-form-component").forEach(attach);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();
}